import { useEffect } from "react";
import { useI18n } from "@/lib/i18n";

const SEO_BY_LOCALE = {
  ca: {
    htmlLang: "ca",
    ogLocale: "ca_ES",
    title: "Aura · Sala d'esdeveniments a Sant Cugat del Vallès | Esdeveniments privats i corporatius",
    description:
      "Sala d'esdeveniments boutique al cor de Sant Cugat del Vallès (Barcelona). Fins a 70 persones, càtering a mida amb xef privat i equipament complet. Reserva la teva data online: aniversaris, batejos, cates, sopars d'empresa, pop-ups.",
    keywords:
      "sala esdeveniments Sant Cugat, sala d'esdeveniments Barcelona, lloguer sala Sant Cugat, sala festes privades Vallès, sopar empresa Sant Cugat, cata de vins Sant Cugat, càtering xef privat, aniversari sala privada, espai per esdeveniments Barcelona, pop-up Sant Cugat",
  },
  es: {
    htmlLang: "es",
    ogLocale: "es_ES",
    title: "Aura · Sala de eventos en Sant Cugat del Vallès | Eventos privados y corporativos",
    description:
      "Sala de eventos boutique en el corazón de Sant Cugat del Vallès (Barcelona). Hasta 70 personas, catering a medida con chef privado y equipamiento completo. Reserva tu fecha online: cumpleaños, bautizos, catas, cenas de empresa, pop-ups.",
    keywords:
      "sala de eventos Sant Cugat, sala eventos Barcelona, alquiler sala Sant Cugat, sala fiestas privadas Vallès, cena empresa Sant Cugat, cata de vinos Barcelona, catering chef privado, cumpleaños sala privada, espacio eventos Barcelona, pop-up Sant Cugat",
  },
  en: {
    htmlLang: "en",
    ogLocale: "en_GB",
    title: "Aura · Event venue in Sant Cugat del Vallès, Barcelona | Private & corporate events",
    description:
      "Boutique event venue in the heart of Sant Cugat del Vallès (Barcelona). Up to 70 guests, custom catering with private chef and full A/V kit. Book your date online: birthdays, christenings, wine tastings, corporate dinners, pop-ups.",
    keywords:
      "event venue Sant Cugat, event space Barcelona, private party venue Vallès, corporate dinner Barcelona, wine tasting venue, catering private chef, birthday venue, event space rental Barcelona, pop-up Sant Cugat",
  },
};

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.create || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs.set || {}).forEach(([k, v]) => el.setAttribute(k, v));
};

export default function SEOHead() {
  const { locale } = useI18n();

  useEffect(() => {
    const seo = SEO_BY_LOCALE[locale] || SEO_BY_LOCALE.ca;
    document.documentElement.lang = seo.htmlLang;
    document.title = seo.title;

    upsertMeta('meta[name="title"]', { create: { name: "title" }, set: { content: seo.title } });
    upsertMeta('meta[name="description"]', { create: { name: "description" }, set: { content: seo.description } });
    upsertMeta('meta[name="keywords"]', { create: { name: "keywords" }, set: { content: seo.keywords } });

    upsertMeta('meta[property="og:locale"]', { create: { property: "og:locale" }, set: { content: seo.ogLocale } });
    upsertMeta('meta[property="og:title"]', { create: { property: "og:title" }, set: { content: seo.title } });
    upsertMeta('meta[property="og:description"]', { create: { property: "og:description" }, set: { content: seo.description } });

    upsertMeta('meta[name="twitter:title"]', { create: { name: "twitter:title" }, set: { content: seo.title } });
    upsertMeta('meta[name="twitter:description"]', { create: { name: "twitter:description" }, set: { content: seo.description } });
  }, [locale]);

  return null;
}
